export default __webpack_public_path__ + "static/media/apple_safari.0c17c944.svg";